var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16.5,
    fill: "#008FDF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7137 15.3753C18.9734 14.2153 19.1547 13.3763 19.258 12.8566C19.518 11.5483 18.8429 10.3333 17.5047 10.3333C16.298 10.3333 15.692 10.9329 15.3347 12.1316L15.3255 12.1666C15.111 13.1363 14.783 13.8879 14.3489 14.4258C14.1229 14.7063 13.8385 14.9341 13.5153 15.0933C13.1922 15.2524 12.8381 15.339 12.478 15.3471L12.1357 15.3544C11.3194 15.3719 10.6667 16.0439 10.6667 16.8671V21.8333C10.6667 22.8458 11.4809 23.6666 12.4854 23.6666H18.931C20.255 23.6666 21.4369 22.8296 21.886 21.5741L23.225 17.8306C23.5657 16.8781 23.076 15.8274 22.1312 15.4839C21.9334 15.412 21.7246 15.3752 21.5142 15.3753H18.7137Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.600107ce9ad5b03ea42229134ff01f56.svg";
export { ForwardRef as ReactComponent };